import { EventEmitter, Injectable } from '@angular/core';
import { HubConnectionBuilder, HubConnection, HttpTransportType } from '@microsoft/signalr';
import { environment as env } from '../../../environments/environment';
import * as signalR from '@microsoft/signalr';
import { LgvAuth0Service } from './lgv-auth0.service';
import { filter, mergeMap, of, take, zip } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LgvUserService } from './lgv-user.service';
import { LgvAuthMgrService } from './lgv-auth-mgr.service';

@Injectable({
    providedIn: 'root'
})

export class LgvSignalRService {
    private hubConnection: HubConnection;
    onNewEmail: EventEmitter<any> = new EventEmitter();

    public get connectionState(): signalR.HubConnectionState {
        return this.hubConnection.state;
    }

    get isConnectionActive(): boolean {
        return this.hubConnection?.state === signalR.HubConnectionState.Connected;
    }

    constructor(
        private auth0Svc: LgvAuth0Service,
        private authMgrSvc: LgvAuthMgrService,
        private lgvUserSvc: LgvUserService,
        private http: HttpClient
    ) { 
        this.startConnection();
    }


    public startConnection() {

        if (this.isConnectionActive) {
            return;
        }

        // step 1: get logged in user / agent id
        this.lgvUserSvc.AgentDTO$.pipe(
            filter(f => !!f && !this.authMgrSvc.IsClient),
            take(1),
            mergeMap((agentDTO) => {
                // step 2: get Auth0 token
                return zip(
                    of(agentDTO),
                    this.auth0Svc.getTokenSilently$().pipe(take(1))
                );
            }),
            // filter out connection attempts for users that don't have a mailbox / username
            filter(([agentDTO, auth0Token]) => !!agentDTO.agentInfo.username),
            mergeMap(([agentDTO, auth0Token]) => {
                // step 3: get signalR connection token

                let bldUrl = `${env.LgvApiBaseUrl}/users/${agentDTO.agentInfo.id}/push-notifications/emailhub/connect`;
                const headers = new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth0Token}`
                });
                return this.http.post<any>(bldUrl, null, { headers })
            }),
            mergeMap((connectionResponse) => {

                // step 4: start hub connection
                const { hubUrl, accessToken } = connectionResponse;

                this.hubConnection = new signalR.HubConnectionBuilder()
                    .withUrl(hubUrl, {
                        accessTokenFactory: () => accessToken
                    })
                    .build();

                return this.hubConnection.start()
            })

        ).subscribe(() => {
            // final step: listen for desired events.  So far, we just have "NewEmail" events

            // listen for emails...
            this.hubConnection.on('NewEmail', (email: any) => {

                // give some time for the backend to process the email
                setTimeout(() => {
                    this.onNewEmail.emit(email);
                }, 2000);
                
            });

        });

    }

}